import React from "react";
import { Carousel } from "antd";
import Nav2 from "../../assets/img/img_shouye_toutu2.jpg";
const style = [
  {
    width: "100%",
    height: "100%",
    background: "require('../../assets/img/img_shouye_toutu.jpg')",
    text:'数字技术服务公共安全',
  },
  // {
  //   width: "100%",
  //   height: "100%",
  //   background: "require('../../assets/img/img_shouye_toutu.jpg')",
  //   text: "数字技术服务公共安全",
  // },
  // {
  //   width: "100%",
  //   height: "100%",
  //   background: "require('../../assets/img/img_shouye_toutu.jpg')",
  //   text: "数字技术服务公共安全",
  // },
  // {
  //   width: "100%",
  //   height: "100%",
  //   background: "require('../../assets/img/img_shouye_toutu.jpg')",
  //   text: "数字技术服务公共安全",
  // },
];
const word = {
  style: {
    fontSize: "48px",
    fontFamily: "PingFangSC-Semibold, PingFang SC",
    fontWeight: "600",
    color: "#FFFFFF",
    lineHeight: "64px",
    letterSpacing: "10px",
    textShadow: "1px 1px 0px rgba(0, 0, 0, 0.3)",
    position:'absolute',
    top:0,
    left:0,
    right:0,
    bottom:0,
    margin:'auto auto',
    zIndex:100,
    height:64
  },
};
const img_b ={
    style:{
    width:'100%',
    heigth:560
    }
}
class Carous extends React.Component {
  render() {
    return (
      <div>
        <div>
          <h3 style={{ position: "relative",minHeight:350 }}>
            <img src={Nav2} style={img_b.style}/>
            <span style={word.style}>数字技术服务公共安全</span>
          </h3>
        </div>
        {/* <div>
          <h3 style={{ position: "relative" }}>
            <img src={Nav2} style={img_b.style} />
            <span style={word.style}>公共安全解决方案专家</span>
          </h3>
        </div>
        <div>
          <h3 style={{ position: "relative" }}>
            <img src={Nav2} style={img_b.style}/>
            <span style={word.style}>公共安全解决方案专家</span>
          </h3>
        </div>
        <div>
          <h3 style={{ position: "relative" }}>
            <img src={Nav2} style={img_b.style} />
            <span style={word.style}>公共安全解决方案专家</span>
          </h3>
        </div> */}
      </div>
    );
  }
}

export default Carous;
